module.exports = "/_next/static/images/telegram_footer-799caa74ceabca937f2b82b60b2918f0.png";